import { Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { of } from 'rxjs';

import { BadgeModule } from '@openng/optimus-ui/badge';

import { rxResourceFixed, CurrencyService } from '@zayan-erp/shared';
import { DsmApsService } from '../../services/dsm-aps.service';

@Component({
  selector: 'dsm-build-spec-overview',
  templateUrl: './dsm-build-spec-overview.component.html',
  imports: [CommonModule, BadgeModule]
})
export class DsmBuildSpecOverviewComponent {
  buildSpecId = input.required<string>();

  #service = inject(DsmApsService);
  #currencyService = inject(CurrencyService);

  // Same API as sales: GET /Lot/spec-lots/{lotId}
  specLotResource = rxResourceFixed({
    params: () => ({ lotId: this.buildSpecId(), refresh: this.#service.refreshTrigger() }),
    defaultValue: null,
    stream: ({ params }) => {
      if (!params.lotId) return of(null);
      return this.#service.getSpecLotDetails(params.lotId);
    }
  });

  specLot = computed(() => this.specLotResource.value());

  fmt(value: number | null | undefined): string {
    if (value == null) return '—';
    return this.#currencyService.formatCurrency(value, '1.2-2') || '—';
  }

  get elevationLabel(): string {
    const elev = this.specLot()?.selectedElevation;
    if (!elev) return '—';
    const code = elev.elevationCode;
    const desc = elev.description;
    if (code && desc) return `${code} - ${desc}`;
    return code ?? '—';
  }

  get modelLabel(): string {
    const specLot = this.specLot();
    if (specLot?.selectedModel) return specLot.selectedModel.modelName;
    if (specLot?.models?.length) return specLot.models[0].modelName;
    return '—';
  }
}
